import PublicNav from "@/components/nav/PublicNav";
import Footer from "@/components/nav/Footer";
import { TrialCTA } from "@/components/trial/TrialCTA";

export default function About() {
  return (
    <div className="min-h-screen bg-obsidian text-ivory">
      <PublicNav />
      <section className="border-b border-line">
        <div className="max-w-4xl mx-auto px-6 md:px-10 py-24 md:py-32">
          <div className="brand-eyebrow mb-6">ABOUT</div>
          <h1 className="brand-headline text-6xl md:text-8xl">The future of work<br /><span className="text-purple italic">isn&apos;t human.</span></h1>
          <p className="text-steel text-lg md:text-xl mt-10 leading-relaxed">
            Hired builds AI employees for the operational back-office of specialist businesses. We&apos;re starting where the paperwork is heaviest and the tools are thinnest: <span className="text-ivory">HOA management</span>, <span className="text-ivory">real estate</span>, and <span className="text-ivory">construction &amp; home services</span>.
          </p>
          <p className="text-steel text-lg mt-6 leading-relaxed">
            Steward runs the HOA back office. HomiHQ keeps every listing, lead, and transaction on the rails. Foundation First helps contractors track permits, coordinate subs, and prepare Louisiana 811 DigSafe utility-locate requests. One kit. Three verticals. More coming.
          </p>
          <p className="text-steel text-lg mt-6 leading-relaxed">
            We don&apos;t sell software. We sell help. Every employee we ship is measured by one thing: the work that got done while you were somewhere else.
          </p>
          <div className="mt-12">
            <TrialCTA testid="about-cta" />
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
